/**
 * acknowledge-watchlist-alert-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link AcknowledgeWatchlistAlertRequest} to remove the
 * notification flag from a watchlist entry, typically to signal that the user
 * has acknowledged the alert and no longer needs it to be presented.
 */
export class AcknowledgeWatchlistAlertRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_ACKNOWLEDGE_WATCHLIST_ALERT;
	public static tag : MessageTag = MessageTag.REQ_ACKNOWLEDGE_WATCHLIST_ALERT;

  /**
   * Construct a new {@link AcknowledgeWatchlistAlertRequest}.
   */
  constructor (public objectId : number, public watchId : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/acknowledge-watchlist-alert-request.ts